export interface IPasswordPolicy {
    isValid(password: string): boolean;
}

export enum PolicyNames {
    MaximumPasswordLength,
    MinimumPasswordLength,
    MustContainLetters,
    MustContainNumbers,
    MustContainSymbols,
    MustContainUppercaseLetters,
}
